/** Pages a signed-in user without a team may open; everything else sends them to team setup. */
const PAGES_WITHOUT_A_TEAM: readonly string[] = ['/teams', '/feedback'];

/** True when a signed-in user has no team and is on a page that needs one. */
export function needsTeamRedirect(
    user: { teamId?: string | null } | null | undefined,
    pathname: string,
): boolean {
    return !!user && !user.teamId && !PAGES_WITHOUT_A_TEAM.includes(pathname);
}
